import { Label } from "components/atoms";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  PiSealCheck,
  PiSealPercent,
  PiSealQuestion,
  PiSealQuestionFill,
  PiSealWarning,
  PiX,
  PiXCircleFill,
} from "react-icons/pi";
import { CONTRACT_STATUS } from "services/contract/types";
import { IColorProp } from "types/components/components.interface";

export interface ILabeledContractStatusProps {
  status: CONTRACT_STATUS;
  onlyIcon?: boolean;
}

interface ILabeledContractStatusParams extends IColorProp {
  status: CONTRACT_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledContractStatusParams[] = [
  {
    status: CONTRACT_STATUS.unknown,
    color: "gray",
    icon: <PiSealQuestion />,
  },
  {
    status: CONTRACT_STATUS.offer,
    color: "orange",
    icon: <PiSealQuestionFill />,
  },
  {
    status: CONTRACT_STATUS.active,
    color: "blue",
    icon: <PiSealCheck />,
  },
  {
    status: CONTRACT_STATUS.withdraw,
    color: "gray",
    icon: <PiSealWarning />,
  },
  {
    status: CONTRACT_STATUS.rejected,
    color: "red",
    icon: <PiXCircleFill />,
  },
];

const LabeledContractStatus = ({
  status,
  onlyIcon = false,
}: ILabeledContractStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find((params) => params.status === status) ??
    labeledStatusParams[0];

  return (
    <Label
      size="compact"
      color={labeledParams.color}
      title={t(`enum.CONTRACT_STATUS.${CONTRACT_STATUS[labeledParams.status]}`)}
      className={`global-contract-status ${
        CONTRACT_STATUS[labeledParams.status]
      }`}
    >
      {labeledParams.icon}{" "}
      {!onlyIcon &&
        t(`enum.CONTRACT_STATUS.${CONTRACT_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledContractStatus;
